import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadWebAccessibilityChecklist'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'アクセシビリティ ウェブアクセシビリティ'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/download/webaccessibilitychecklist/'}
        title="ウェブアクセシビリティチェックリスト | 資料ダウンロード | i3DESIGN アイスリーデザイン"
        description="ウェブアクセシビリティをどこまで実現できているかを図る指標としてチェックリストを作成しました。本資料は、国家規格を基とした、ウェブアクセシビリティ基盤委員会が提供する「JIS X 8341-3:2016試験実施ガイドライン」を、独自の解釈でより簡略化したものとなっています。"
      />
      <Template />
    </>
  )
}

export default Download
